export function fileCollectionFromPath() {
    throw new Error('This method is not available in the browser');
}
//# sourceMappingURL=fileCollectionFromPath.browser.js.map